import React from "react";
import { useTranslation } from "lib/i18n";

const AiReadinessFunnel = () => {
  const { t } = useTranslation();
  const stages = Array.isArray(t("aiFunnel.stages")) ? t("aiFunnel.stages") : [];
  const outcomes = Array.isArray(t("aiFunnel.outcomes")) ? t("aiFunnel.outcomes") : [];

  return (
    <section className="ai-funnel-section text-white">
      <div className="container">
        <div className="ai-funnel-shell">
          <div className="ai-funnel-header">
            <p className="ai-section-eyebrow title-font-2">{t("aiFunnel.eyebrow")}</p>
            <h2 className="title-font">{t("aiFunnel.heading")}</h2>
            <p className="title-font-2">{t("aiFunnel.body")}</p>
          </div>

          <div className="ai-funnel-layout">
            <div className="ai-funnel-stages" aria-label={t("aiFunnel.stagesHeading")}>
              {stages.map((stage, index) => (
                <article className="ai-funnel-stage" key={stage.step}>
                  <div className="ai-funnel-stage-marker title-font">{stage.step}</div>
                  <div className="ai-funnel-stage-body">
                    <p className="ai-funnel-stage-eyebrow title-font-2">
                      {stage.eyebrow || `${t("aiFunnel.stageLabel")} ${index + 1}`}
                    </p>
                    <h3 className="title-font-2">{stage.title}</h3>
                    <p className="title-font-2">{stage.description}</p>
                    <span className="ai-funnel-stage-result title-font-2">
                      {t("aiFunnel.resultLabel")}: {stage.result}
                    </span>
                  </div>
                </article>
              ))}
            </div>

            <aside className="ai-funnel-outcome" aria-label={t("aiFunnel.outcomeHeading")}>
              <p className="ai-funnel-outcome-eyebrow title-font-2">{t("aiFunnel.outcomeEyebrow")}</p>
              <h3 className="title-font">{t("aiFunnel.outcomeHeading")}</h3>
              <div className="ai-funnel-outcome-list">
                {outcomes.map((outcome) => (
                  <div className="ai-funnel-outcome-item" key={outcome}>
                    <span className="title-font-2">{outcome}</span>
                  </div>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiReadinessFunnel;
